export const translationHashes = {
  "de-DE": "0f9c3790",
  "en-CA": "e92cc492",
  "en-GB": "02bfb649",
  "en-US": "818c3482",
  "es-ES": "b2f751f2",
  "es-US": "49b66bcb",
  "formattings": "12664509",
  "fr-CA": "4c6d348a",
  "nl-NL": "8beb2125",
  "sv-SE": "b985263c"
} as {[lang: string]: string};